import { computed } from 'vue'
import { useRoute } from 'vue-router'

export function useIsActiveRoute(routeNames: Set<string>) {
    const route = useRoute()

    routeNames.has(route?.name as string)
    const isActive = computed(() => routeNames.has(route?.name as string))

    return { isActive }
}
